"use client"

import type { CategoryExpressContentProps } from "@/types/types"
import { useCategoryExpress } from "../hooks/useCategoryExpress"
import "./categoryExpress.css"
import { CategoryExpressItem } from "./CategoryExpressItem"

export const CategoryExpressContent = ({ id, title, items = [], className = "" }: CategoryExpressContentProps) => {
  const { validItems, hasValidItems, itemRefs } = useCategoryExpress({
    items,
    componentId: id,
  })

  if (!hasValidItems) {
    return null
  }

  return (
    <div className={`w-full ${className}`} id={id}>
      <div className="max-w-full sm:max-w-[1304px] mx-auto sm:pb-11 sm:pt-3 pb-4 pt-4 px-4 sm:px-2">
        {title && (
          <h2 className="text-left text-lg sm:text-2xl sm:px-0 font-bold pb-[2.375rem] sm:pb-5 pt-4 sm:pt-0 sm:leading-[2.325rem] leading-[1.625rem] text-[#333333]">
            {title}
          </h2>
        )}

        {/* Desktop Grid Layout - 4 columns */}
        <div className="hidden sm:grid sm:grid-cols-4 sm:gap-4 sm:justify-items-center sm:items-start px-4 sm:px-0">
          {validItems.map((item, index) => (
            <div key={index} className="w-full flex justify-center">
              <CategoryExpressItem item={item} />
            </div>
          ))}
        </div>

        {/* Mobile Grid Layout - 2 columns */}
        <div className="grid grid-cols-2 gap-2 sm:hidden">
          {validItems.map((item, index) => (
            <div
              key={index}
              ref={el => {
                itemRefs.current[index] = el
              }}
              className="w-full flex justify-center"
            >
              <CategoryExpressItem item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
